import { render, staticRenderFns } from "./RaDomItem.vue?vue&type=template&id=d904db34&scoped=true&"
import script from "./RaDomItem.vue?vue&type=script&lang=js&"
export * from "./RaDomItem.vue?vue&type=script&lang=js&"
import style0 from "./RaDomItem.vue?vue&type=style&index=0&id=d904db34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d904db34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
